import { Property } from "@flatfile/api/api";
import { FFValidator } from "src/utils";
import { INTEGER_VALIDATOR } from "./Validators";

export const MeritAdjustmentFields: Property[] = [
  {
    label: "Merit Adjustment ($)",
    key: "salaryMerit",
    type: "number",
  },
  {
    label: "Merit Adjustment (%)",
    key: "salaryMeritPercent",
    type: "number",
  },
  {
    label: "Merit Notes",
    key: "salaryMeritNotes",
    type: "string",
  },
];

export const getMeritAdjustmentValidators = () => [
  FFValidator.regexMatches(
    "salaryMerit",
    RegExp(INTEGER_VALIDATOR),
    "Must be a whole number"
  ),
];
